function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawGifts = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1119 732.13",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 729.01,
    y1: 758.4,
    x2: 729.01,
    y2: 122.4,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: -861.71,
    y1: 737.12,
    x2: -861.71,
    y2: 290.85,
    gradientTransform: "translate(1240.08)",
    xlinkHref: "#prefix__a"
  })), React.createElement("ellipse", {
    cx: 559.5,
    cy: 644.13,
    rx: 559.5,
    ry: 88,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#f86d70",
    d: "M927.33 472.98v61l-16.13 32.54-.51 1.03-42.69-2.82-16.41-1.09-38.09-2.51v-72.97l38.09 1.07 17.03.48 43.09 1.22 15.62-17.95z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M927.33 476.58v57.4l-3.95 7.95-4.03 8.15-8.15 16.44.91-61 .18-12.31 7.75-8.57 3.38-3.74 3.91-4.32z"
  }), React.createElement("path", {
    fill: "#f86d70",
    d: "M929.51 456.78v21.31l-2.18 3.49-3.92 6.23-3.46 5.52-7.66 12.2-.18-.01-101.97-5.25v-21.01l.26-.28 12.17-13.18 4.41-4.77 7.97-8.62 94.56 4.37z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M912.29 484.51v21.02l-102.15-5.26v-21.01l.26-.28 101.89 5.53z"
  }), React.createElement("path", {
    opacity: 0.15,
    d: "M929.51 456.78v21.31l-17.22 27.44v-21.02l17.22-27.73z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M923.43 466.59l-.01 14.31-.01 6.91-.03 54.12-4.03 8.15.6-56.75.09-8.69.14-12.82-97.61-6.02 4.41-4.77 96.45 5.56z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M875.52 467.29l-6.84 14.85-.06 7.57-.62 75.02-16.41-1.09v-82.49l8.75-13.86h15.18z"
  }), React.createElement("path", {
    d: "M853 468.29a21.62 21.62 0 0 1-12.24.43 4.9 4.9 0 0 1-2.14-1 5.58 5.58 0 0 1-1.33-2.63 20.69 20.69 0 0 1-1.17-6.29 7 7 0 0 1 2.62-5.62 6.13 6.13 0 0 0 1-.75 4.22 4.22 0 0 0 .77-1.56c1.2-3.57 3.51-7.33 7.23-7.91 3.43-.52 6.55 1.87 9.2 4.12l5.8 4.94a9.15 9.15 0 0 1 17.07-.23 32.37 32.37 0 0 1 12.9-8.86 4 4 0 0 1 3.39-.13 3.78 3.78 0 0 1 1.35 1.81 27.85 27.85 0 0 1 2.52 11 1.93 1.93 0 0 1 2.24.77 5.09 5.09 0 0 1 .74 2.42 33.41 33.41 0 0 1 .23 4 6 6 0 0 1-1 4c-1.18 1.38-3.23 1.52-5 1.56.88.78.45 2.35-.52 3a5.84 5.84 0 0 1-3.39.66c-4.51 0-9.31-.17-13.07-2.67-1.48-1-2.72-2.31-4.21-3.3-3.64-2.41-8.22-2.52-12.43-2.32-3.92.19-6.94 3.34-10.56 4.56z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M852.17 467.3s-37.65 5.25-42.91 28l7.89-1.16 5.54 9.92s5.84-22.18 23.06-27.44 23.35-6.12 23.35-6.12 12 2.91 22.76 37.65l6.13-8.47 10.8 2.34s-7.88-27.15-29.19-34.73z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M874.71 496.84v82.4l-21.78 43.94v.01l-.69 1.39-57.67-3.81-22.17-1.47-51.45-3.4v-98.56l51.45 1.45 23.01.65 58.21 1.64 21.09-24.24z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M874.71 501.7v77.54l-5.32 10.73v.01l-5.46 11-11 22.2 1.23-82.4.25-16.62 10.46-11.57v-.01l4.56-5.04 5.28-5.84z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M877.67 474.95v28.79l-2.96 4.71-5.28 8.41-4.68 7.46-10.34 16.48-.25-.02-137.74-7.08v-28.39l.34-.37 16.45-17.8 5.95-6.45 10.77-11.65 127.74 5.91z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M854.41 512.41v28.39l-137.99-7.1v-28.39l.34-.37 137.65 7.47z"
  }), React.createElement("path", {
    opacity: 0.15,
    d: "M877.67 474.95v28.79l-23.26 37.06v-28.39l23.26-37.46z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M869.45 488.2l-.02 19.34v9.32l-.04 73.11v.01l-5.46 11 .82-76.66.12-11.73v-.01l.19-17.32-131.85-8.12 5.95-6.45 130.29 7.51z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M804.73 489.15l-9.24 20.06-.08 10.23-.84 101.33-22.17-1.47V507.88l11.83-18.73h20.5z"
  }), React.createElement("path", {
    d: "M774.31 490.5a29.26 29.26 0 0 1-16.53.58 6.57 6.57 0 0 1-2.89-1.34 7.51 7.51 0 0 1-1.8-3.55 28 28 0 0 1-1.58-8.51c.07-2.89 1.17-5.91 3.54-7.58a9.4 9.4 0 0 0 1.34-1 5.56 5.56 0 0 0 1-2.11c1.61-4.82 4.74-9.91 9.77-10.68 4.63-.71 8.85 2.52 12.42 5.56l7.83 6.67a12.37 12.37 0 0 1 23.06-.31 43.78 43.78 0 0 1 17.43-12c1.49-.56 3.23-1 4.59-.18a5.21 5.21 0 0 1 1.82 2.44 37.74 37.74 0 0 1 3.4 14.86 2.6 2.6 0 0 1 3 1 6.89 6.89 0 0 1 1 3.28 46.27 46.27 0 0 1 .32 5.39c0 1.9-.18 4-1.42 5.4-1.6 1.86-4.37 2.06-6.82 2.12 1.18 1.05.6 3.16-.71 4.05a7.86 7.86 0 0 1-4.58.89c-6.1-.06-12.58-.23-17.65-3.62-2-1.33-3.68-3.11-5.69-4.44-4.92-3.26-11.1-3.41-16.8-3.14-5.08.31-9.16 4.58-14.05 6.22z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M773.19 489.15s-50.86 7.1-58 37.85l10.65-1.58 7.49 13.41s7.89-30 31.15-37.06 31.54-8.28 31.54-8.28 16.16 3.94 30.75 50.86l8.28-11.44 14.63 3.16s-10.65-36.67-39.43-46.92zM957.25 537.77v51l-13.48 27.2-.43.86-35.69-2.36-13.72-.91-31.84-2.1v-61l31.84.89 14.24.4 36.03 1.02 13.05-15z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M957.25 540.77v48l-3.29 6.64-3.38 6.81v.01l-6.81 13.74.76-51 .16-10.29 6.47-7.17 2.83-3.12 3.26-3.62z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M959.08 524.22v17.82l-1.83 2.91-3.27 5.21-2.89 4.62-6.4 10.19h-.16l-85.25-4.39v-17.57l.21-.23 10.18-11.02 3.69-3.98 6.66-7.22 79.06 3.66z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M944.69 547.4v17.57l-85.41-4.39v-17.57l.21-.23 85.2 4.62z"
  }), React.createElement("path", {
    opacity: 0.15,
    d: "M959.08 524.22v17.82l-14.39 22.93V547.4l14.39-23.18z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M953.99 532.42v11.97l-.01 5.77-.02 45.25-3.38 6.81.51-47.44.07-7.27.12-10.72-81.61-5.03 3.69-3.98 80.63 4.64z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M913.94 533.01l-5.72 12.42-.05 6.32-.52 62.72-13.72-.91V544.6l7.32-11.59h12.69z"
  }), React.createElement("path", {
    d: "M895.11 533.85a18.18 18.18 0 0 1-10.23.36 4.17 4.17 0 0 1-1.79-.84 4.71 4.71 0 0 1-1.11-2.19 17.35 17.35 0 0 1-1-5.27 5.85 5.85 0 0 1 2.19-4.69 5 5 0 0 0 .83-.63 3.44 3.44 0 0 0 .64-1.3c1-3 2.94-6.13 6.05-6.61 2.87-.44 5.48 1.56 7.69 3.44l4.85 4.13a7.65 7.65 0 0 1 14.27-.18 27.22 27.22 0 0 1 10.79-7.4 3.32 3.32 0 0 1 2.83-.11 3.18 3.18 0 0 1 1.13 1.51 23.2 23.2 0 0 1 2.1 9.2 1.6 1.6 0 0 1 1.87.64 4.32 4.32 0 0 1 .63 2 28.77 28.77 0 0 1 .19 3.34 5 5 0 0 1-.88 3.34c-1 1.16-2.7 1.28-4.22 1.31a1.7 1.7 0 0 1-.43 2.51 4.9 4.9 0 0 1-2.84.55c-3.77 0-7.79-.14-10.93-2.24-1.24-.82-2.28-1.92-3.52-2.75-3-2-6.87-2.11-10.39-1.94-3.17.16-5.69 2.8-8.72 3.82z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M894.42 533.01s-31.48 4.39-35.87 23.43l6.59-1 4.63 8.3s4.88-18.55 19.28-22.94 19.52-5.12 19.52-5.12 10 2.44 19 31.47l5.13-7.07 9 2s-6.59-22.69-24.4-29z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M871.58 249.86c-1.12-6.7-21.9-21.2-21.9-21.2s-9.17-5-14-10.79c-3.11-3.68-4.08-3.64-4.37-3.14a1.5 1.5 0 0 0-.68-.23c-.19-.14-.38-.27-.56-.42a1.34 1.34 0 0 0-.77-1.37 7.69 7.69 0 0 1-.71-.5c-1.58-2.68-2.14-6.5-2.33-9.82-.23-4.2-5-3.14-6.51-2.68-1.1-2.09-2.18-4.28-3.19-6.46a11.48 11.48 0 0 0 1.04-2.25c2.9-6.4 2.26-13.73 3.52-20.49.91-4.9 2.79-10 2.42-14.77v-.35a.17.17 0 0 1 0 .07 12.92 12.92 0 0 0-.8-3.48c-.83-2.15-2.29-4-3-6.23-1.05-3.22-.38-6.78-1.25-10.06-1.09-4.14-4.54-7.35-8.44-9.18s-8.22-2.46-12.49-3c-10.68-1.36-22-2.17-31.75 2.39a5.56 5.56 0 0 1-3 .81 8.88 8.88 0 0 1-2.7-1.27c-2.62-1.32-5.91-.48-8.24 1.29s-3.92 4.3-5.48 6.76-3.23 5-5.65 6.61c-2.85 1.93-6.61 2.58-8.83 5.19a8.39 8.39 0 0 0-1.84 4.32.17.17 0 0 0 0-.07V150.95a10.78 10.78 0 0 0 0 1.27 27.62 27.62 0 0 0 1.89 7.1 9.9 9.9 0 0 0 2.58 4.46c3.42 2.84 8.82.16 13 1.74a9.88 9.88 0 0 1 1 .47l-.15.48a34 34 0 0 0 32.92 43.45c.7 0 1.4 0 2.1-.08.1.37.21.74.3 1.11a37.57 37.57 0 0 1 1 12.72l-.21-1.85a9.48 9.48 0 0 0-1.42-.56 12.6 12.6 0 0 0-4.25-.65c-4.65-.07-11.66 1.84-19.13 11.06 0 0-9.54 5.4-12.35 6.7a1.39 1.39 0 0 0-.52.6S734.21 258.6 732.9 266l-.18 1-21.4-1a39.51 39.51 0 0 0-3.6-15.41 5.51 5.51 0 0 0-1.94-2.58c-1.43-.87-3.29-.4-4.87.19a46.57 46.57 0 0 0-18.53 12.63 13.18 13.18 0 0 0-24.51.33l-8.33-7c-3.79-3.21-8.27-6.63-13.2-5.88-5.34.82-8.67 6.19-10.39 11.28a5.83 5.83 0 0 1-1.1 2.23 3.88 3.88 0 0 1-.31.26l-6.56-.3-11.44 12.3-6.33 6.81-17.48 18.8-.37.39v18.78a34.14 34.14 0 0 0-1.26 4.17l1.26-.19v7.26l4.82.25v86.57l54.69 3.59 23.57 1.52 41.65 2.73c0 3.93 1.64 9.45 5.13 11.62a9.6 9.6 0 0 1 2.3 2.07c-.18.35-.36.71-.53 1.07-1.67 3.45-3.15 7.3-2.89 9.69a13.28 13.28 0 0 1-2 8.65s-12.6 39.75-12.32 51.17-4.49 36.53-4.49 36.53-5.2 16.18-2.11 20.78 6.6 24.69 6.6 24.69 2.39 4.6 2.24 8.51 2.25 11 2.25 11l7.86 28.87s-.84 7.67 2.11 13.11 2.66 3.76 1.26 13.25 1.68 18.27 6.74 21.06c2 1.08 2.06 2.73 1.45 4.34h-.05c-1.29-.51-2.36 2.2-3 4.39-.39.4-.65.63-.65.63l.44.11c-.28 1.05-.44 1.84-.44 1.84s-13.19 11.16-14 15.2-10.11 6.14-10.11 6.14-14 3.9-17.69 5.86a6.73 6.73 0 0 0-3.87 5.41 15.2 15.2 0 0 0 .5 5.46c1.41 5.72 21.06 6.28 30.46 4.75s28.92-7.12 28.92-7.12 20.49-2 26.53-4.46 1.26-8.92 1.26-8.92v-.61c.15-2.33.57-10.79-.88-13.06-1.1-1.72-1.06-6-.91-8.73 4.1-7.5-4.71-30-4.71-30s1.69-22 .56-25.24-5.89-30.54-5.89-30.54-2.95-12.42-1.83-14.51-.7-8.09-.7-8.09-4.77-6.69-4.35-8.78-1.4-5.86-1.4-5.86 14.32-21.76 13.05-25.8.56-10.6.56-10.6l4-6.77c2.66-4.52 5.88-9.95 7-11.64 1.38-2.15 4.7-11.3 6.55-16.58.78-2.24 1.31-3.78 1.31-3.78s2.25 41 4.21 45.19 4.92 37.23 4.92 37.23a23.2 23.2 0 0 1 1.4 9.21c-.28 5.16 4.49 27.61 4.49 27.61s2.11 15.9.7 20.08-.28 35-.28 35-7.72 6-9.68 10.59.28 17.16.28 17.16l.9.43a26.16 26.16 0 0 0-1.6 5.42c-.28 2.65-4.5 14.65-4.07 16.32s-1.83 6.83-2.11 9.48-3.79 6.56-4.07 8a33.86 33.86 0 0 1-1.55 3.68 36.32 36.32 0 0 0-1.82 5.67c-1.4 5.85 15.3 6.83 15.3 6.83 24.7 4.6 29.2-14.22 29.2-14.22s3.08-16.74 4.21-18a2.08 2.08 0 0 0 .19-1.6 21.81 21.81 0 0 0-3.56-7.89c-.79-.92-.85-3.32-.71-5.46a11.29 11.29 0 0 0 2.11-.39c10-2.93 5.9-19.81 5.9-19.81s6.73-11.15 6.73-15.48 2.39-17.57 2.39-17.57c8.56-15.62 5.19-53.55 6.6-56.62s-2.95-14.5-6.46-19.66-2.1-19.11 0-23.15-2.1-18-2.1-18 4.07-27.06 3.93-31.24 3.5-16.6 3.5-16.6 3.65-6.41 2.81-8.36 2.81-7 1.83-9.21.84-9.06 2.66-13.11c.94-2.07 2.1-7.78 3-12.85l.3-1.67c4.09 2.63 7.81 4.59 9.2 4.06 2.5-1-1.48-14-4.22-22.12.47-.35.66-.62.47-.75-1.68-1.11.19-6.14.19-6.14 9.92-6 6.55-10.41 3.37-13s-1.12-10-2.06-13 1.12-16.55 2.81-26.4a19.18 19.18 0 0 0-.06-6.47c1.81-2.78 3.67-5.7 5.3-8.41 5.61-9.29 17.59-53.55 17.59-53.55l-.08-.23c1.17-2.35 2-4.26 2.51-5.53 3.52-9.75-3.22-38.76-4.34-45.45zm-87.23-25.48l.26-.13v.22zM729.9 699.09a4.43 4.43 0 0 1-1.78-.35z",
    transform: "translate(-40.5 -83.93)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M580.56 293.36c8.22 3.12 27.36 3.47 35.86 3.46h4.18l5.45-11.09-5.45-9.25s-5-1.37-11.64-2.57c-9.8-1.77-23.21-3.15-29.6.82-10.72 6.62-9.52 14.56 1.2 18.63z",
    fill: "#fec2be"
  }), React.createElement("path", {
    d: "M616.42 296.82h4.18l5.45-11.09-5.45-9.25s-5-1.37-11.64-2.57c5.39 3.94 18.35 12.53 7.46 22.91z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M706.68 160.59l-2.41-2.77s-12.39 19.6-13.68 27-3 15.91-3 15.91-3.09 9.6-5.09 13.86-3.88 8.32-4.06 10.17.74 5.92-3.15 8.5-4.81 9.62-4.81 9.62-14 13.68-21.45 14.05-28.66 4.07-27.92 7.77-8.88 5.92-12.76 6.84 25 12 8.14 26.26c0 0 10.72 2.22 11.83 4.81s12.39-1.48 12.39-1.48 2.41-5.73 10.73-6.1 12.57-4.07 12.57-4.63 8.32-5.17 12.95-6.47 10.72-1.85 10.91-3.14 27.73-120.2 27.73-120.2z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M706.68 160.59l-2.41-2.77s-12.39 19.6-13.68 27-3 15.91-3 15.91-3.09 9.6-5.09 13.86-3.88 8.32-4.06 10.17.74 5.92-3.15 8.5-4.81 9.62-4.81 9.62-14 13.68-21.45 14.05-28.66 4.07-27.92 7.77-8.88 5.92-12.76 6.84 25 12 8.14 26.26c0 0 10.72 2.22 11.83 4.81s12.39-1.48 12.39-1.48 2.41-5.73 10.73-6.1 12.57-4.07 12.57-4.63 8.32-5.17 12.95-6.47 10.72-1.85 10.91-3.14 27.73-120.2 27.73-120.2z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M735.5 673.74c24.41 4.58 28.85-14.14 28.85-14.14s3-16.64 4.16-17.89a2.05 2.05 0 0 0 .19-1.59 21.69 21.69 0 0 0-3.52-7.84c-1.53-1.81-.28-9.3-.28-9.3l-28.29-7.21s-2.5 5.69-2.77 8.32-4.44 14.57-4 16.23-1.8 6.8-2.08 9.43-3.74 6.52-4 7.91a34 34 0 0 1-1.53 3.65 35.73 35.73 0 0 0-1.8 5.64c-1.45 5.82 15.07 6.79 15.07 6.79z",
    fill: "#ca8496"
  }), React.createElement("path", {
    d: "M735.5 673.74c24.41 4.58 28.85-14.14 28.85-14.14s3-16.64 4.16-17.89a2.05 2.05 0 0 0 .19-1.59l-5.88 16.84s-4.85 10.13-22.88 8.6c-10.26-.86-15.31-2.77-17.76-4.25a35.73 35.73 0 0 0-1.8 5.64c-1.4 5.82 15.12 6.79 15.12 6.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M754.5 647.39s-6.1.14-6.52-4.85z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M648.38 483.46c3 4.58 6.52 24.55 6.52 24.55s2.36 4.58 2.22 8.46 2.22 11 2.22 11l7.77 28.71s-.84 7.62 2.08 13 2.63 3.75 1.24 13.18 1.67 18.17 6.66 20.94-2.22 9.29-2.22 9.29 31.9 8.6 38.56 3.33-3.47-31.34-3.47-31.34 1.66-21.92.56-25.11-5.83-30.4-5.83-30.4-2.91-12.34-1.8-14.42-.7-8.05-.7-8.05-4.71-6.65-4.3-8.73-1.39-5.8-1.39-5.8 14.14-21.64 12.9-25.66.55-10.54.55-10.54 1.79-3.07 3.94-6.73c2.63-4.5 5.81-9.89 6.88-11.57 1.36-2.15 4.64-11.25 6.47-16.49l1.3-3.76s2.21 40.77 4.16 44.93 4.85 37 4.85 37a23.24 23.24 0 0 1 1.39 9.16c-.28 5.13 4.44 27.46 4.44 27.46s2.08 15.81.69 20-.28 34.81-.28 34.81-7.63 6-9.57 10.54.28 17.06.28 17.06 22.19 11.09 32 8.18 5.82-19.69 5.82-19.69 6.66-11.1 6.66-15.4 2.36-17.47 2.36-17.47c8.46-15.54 5.13-53.26 6.51-56.31s-2.86-14.43-6.35-19.52-2.08-19 0-23-2.06-18-2.06-18 4-26.91 3.89-31.07 3.47-16.5 3.47-16.5 3.6-6.38 2.77-8.32 2.77-6.94 1.8-9.16.83-9 2.64-13c.92-2.07 2.07-7.74 3-12.78.85-4.79 1.48-9 1.48-9L775.6 338.8l-57.14-15-21.5-6.94-20.94 33s-2.16 3.45-4.08 7.43c-1.64 3.43-3.11 7.26-2.85 9.63a13.31 13.31 0 0 1-1.94 8.6s-12.53 39.55-12.25 50.94-4.4 36.34-4.4 36.34-5.17 16.08-2.12 20.66z",
    fill: "#4c4981"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M708.11 209.76v86.55l-22.88 46.16-.73 1.46-60.57-4-23.28-1.54-54.04-3.57V231.29l54.04 1.53 24.17.68 61.13 1.73 22.16-25.47z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M708.11 214.87v81.44l-5.59 11.27v.01l-5.74 11.55v.01l-11.55 23.32 1.29-86.55.26-17.46 10.99-12.16 4.79-5.3 5.55-6.13z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M711.21 186.78v30.23l-3.1 4.95-5.55 8.84-4.92 7.83-10.86 17.3-.26-.01-144.67-7.44v-29.82l.36-.39 17.27-18.7 6.26-6.76 11.3-12.24 134.17 6.21z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M686.78 226.12v29.81l-144.93-7.45v-29.82l.36-.39 144.57 7.85z"
  }), React.createElement("path", {
    opacity: 0.15,
    d: "M711.21 186.78v30.23l-24.43 38.92v-29.81l24.43-39.34z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M702.58 200.69l-.02 20.31v9.8l-.04 76.78v.01l-5.74 11.55.86-80.51.13-12.33.2-18.19-138.49-8.54 6.26-6.76 136.84 7.88z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M634.61 201.69l-9.71 21.07-.08 10.74-.89 106.43-23.28-1.54V221.35l12.42-19.66h21.54z"
  }), React.createElement("path", {
    d: "M602.65 203.07a30.78 30.78 0 0 1-17.35.61 7.07 7.07 0 0 1-3-1.41 7.92 7.92 0 0 1-1.88-3.73 29.55 29.55 0 0 1-1.66-8.93c.07-3 1.23-6.22 3.71-8a8.13 8.13 0 0 0 1.41-1.06 5.66 5.66 0 0 0 1.09-2.21c1.7-5.06 5-10.41 10.26-11.22 4.87-.74 9.3 2.66 13.05 5.85l8.23 7a13 13 0 0 1 24.22-.33 45.94 45.94 0 0 1 18.31-12.56c1.56-.58 3.39-1.06 4.81-.19a5.51 5.51 0 0 1 1.91 2.57 39.47 39.47 0 0 1 3.57 15.6 2.73 2.73 0 0 1 3.17 1.1 7.17 7.17 0 0 1 1.06 3.44 48.74 48.74 0 0 1 .33 5.67c0 2-.19 4.15-1.49 5.67-1.68 1.95-4.58 2.16-7.16 2.22 1.24 1.1.63 3.32-.74 4.26a8.32 8.32 0 0 1-4.82.93c-6.4-.06-13.21-.24-18.54-3.8-2.1-1.4-3.86-3.27-6-4.67-5.17-3.42-11.66-3.58-17.64-3.3-5.42.32-9.71 4.81-14.85 6.49z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M601.5 201.69s-53.42 7.45-60.88 39.75l11.19-1.65 7.86 14.08s8.29-31.48 32.72-38.93 33.12-8.7 33.12-8.7 17 4.15 32.3 53.42l8.7-12 15.32 3.32s-11.18-38.51-41.41-49.28z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M732.87 161.97c.88-.36 61.21-25.27 52.9-30.23-4.93-2.94-11-15.39-15.16-25.14-2.9-6.82-4.87-12.3-4.87-12.3s-48.42-8.6-31.09 21.08a54.87 54.87 0 0 1 6.11 14.62c4.94 20.21-7.49 31.6-7.89 31.97z",
    fill: "#fec2be"
  }), React.createElement("path", {
    d: "M734.65 115.38a54.87 54.87 0 0 1 6.11 14.62 33.84 33.84 0 0 0 28.59-20.1 32 32 0 0 0 1.26-3.3c-2.9-6.82-4.87-12.3-4.87-12.3s-48.42-8.6-31.09 21.08z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M704.55 95.13a33.84 33.84 0 0 0 64.8 13.66 33.5 33.5 0 0 0 2.88-13.66 33.84 33.84 0 1 0-67.68 0z",
    fill: "#fec2be"
  }), React.createElement("path", {
    d: "M671.9 357.33c3.55 3.22 4.91 9.35 4.91 9.35s16.69 11.39 15.54 4.16 8.6-36.33 8.6-36.33l-1.11 39.66s53.25-2.49 57.14-6.38 26.63-11.37 26.63-11.37 7 5.59 13.36 9.83c.85-4.79 1.48-9 1.48-9l-22.89-18.44-57.14-15-21.5-6.94-20.94 33s-2.16 3.48-4.08 7.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M670.16 354.2c4.43 2.78 6.1 10.27 6.1 10.27s16.64 11.37 15.53 4.16 8.6-36.34 8.6-36.34l-1.11 39.66s53.26-2.49 57.14-6.38 26.63-11.37 26.63-11.37 19.69 15.81 23.3 14.43-6.38-28.3-6.38-28.3l-10.26-157.55s2.77-46.88-1.39-48.54a6 6 0 0 1-1.75-1.09c-2.74-2.47-3.56-7.47-3.8-11.67-.27-5-6.93-2.5-6.93-2.5l3.88 5-34.37 20.89-.3.19a39.16 39.16 0 0 0-4.13-1.88c-3-1.17-7.09-2.27-9.74-1.17a9.39 9.39 0 0 0-3.64 3.27 41.2 41.2 0 0 0-4.68 9.49l-12.48 21.08s-6.38 28-6.38 29.12-1.94 26.63-4.16 29.4-4.44 16.65-3.61 20.81-1.39 19.69-1.39 19.69c-9.15 7.49-13.87 33-13.87 33s-14.42 28.57-15.53 31.9.28 11.66 4.72 14.43z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M745.35 145.98c3.37 5 13.11 12 13.11 12l28.11-23.74c-2.74-2.47-3.56-7.47-3.8-11.67-.27-5-6.93-2.5-6.93-2.5l.8 1a4.47 4.47 0 0 1-1.2 6.56z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M745.35 144.87c3.37 5 13.11 12 13.11 12l28.11-23.74c-2.74-2.47-3.56-7.47-3.8-11.67-.27-5-6.93-2.5-6.93-2.5l.8 1a4.47 4.47 0 0 1-1.2 6.56z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M732.35 148.61c3.63 4.35 8.78 9.27 8.54 6.8s3.07-7.91 5.18-10.35a15.35 15.35 0 0 0-10.08.27 9.5 9.5 0 0 0-3.64 3.28z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M731.79 146.95c3.64 4.34 8.78 9.27 8.54 6.8s2.73-6.46 4.84-8.9c-3-1.17-7.08-2.27-9.74-1.18a9.34 9.34 0 0 0-3.64 3.28z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 740.89,
    cy: 167.8,
    r: 2.22,
    fill: "#ff718d"
  }), React.createElement("circle", {
    cx: 724.06,
    cy: 227.71,
    r: 2.22,
    fill: "#ff718d"
  }), React.createElement("circle", {
    cx: 705.01,
    cy: 288.37,
    r: 2.22,
    fill: "#ff718d"
  }), React.createElement("circle", {
    cx: 704.46,
    cy: 354.38,
    r: 2.22,
    fill: "#ff718d"
  }), React.createElement("circle", {
    cx: 731.09,
    cy: 196.09,
    r: 2.22,
    fill: "#ff718d"
  }), React.createElement("circle", {
    cx: 716.11,
    cy: 257.67,
    r: 2.22,
    fill: "#ff718d"
  }), React.createElement("circle", {
    cx: 701.5,
    cy: 318.14,
    r: 2.22,
    fill: "#ff718d"
  }), React.createElement("circle", {
    cx: 704.83,
    cy: 361.78,
    r: 2.22,
    fill: "#ff718d"
  }), React.createElement("path", {
    d: "M786.56 134.52s-.37-3.33 4.44 2.4 13.87 10.73 13.87 10.73 20.53 14.42 21.63 21.08 7.76 35.5 4.25 45.12-30.33 55.66-30.33 55.66 7 8.32 5.37 18.12-3.7 23.3-2.78 26.26-1.11 10.35 2 12.94 6.47 7-3.33 12.95c0 0-1.85 5-.19 6.1s-24.59 12.58-34.95 6.47-29-54.92-29.4-65.83 5.73-47 9.06-55.48 13.32-41.6 17.57-49 22.79-47.52 22.79-47.52z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M787.67 134.52s-.37-3.33 4.44 2.4 13.87 10.73 13.87 10.73 20.52 14.42 21.64 21.08 7.76 35.5 4.25 45.12-30.37 55.66-30.37 55.66 7 8.32 5.37 18.12-3.7 23.3-2.78 26.26-1.11 10.35 2 12.94 6.47 7-3.33 12.95c0 0-1.85 5-.19 6.1s-24.59 12.58-34.95 6.47-29-54.92-29.4-65.83 5.73-47 9.06-55.48 13.32-41.6 17.57-49 22.82-47.52 22.82-47.52z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M795.07 165.95s-15.9 17.57-15.35 29.22c0 0-.22-18.86 15.35-29.22zM773.06 194.8c0 .56-10.72 40.5-10.17 45.49s-3.14 19.78-3.14 19.78l-5-1.3s3.88-20.52 4.62-28.1 13.69-35.87 13.69-35.87zM768.81 308.71c.37.56 25.34 28.85 18.31 30.88s-18.31-30.88-18.31-30.88zM789.34 301.5c.55.37 10 20.34 11.09 15s-8.13 14.61-9.61-.19zM741.4 140.8s-10.31-6.28-23.26 9.8c0 0-9.43 5.37-12.2 6.66s-5.92 35.69-5.92 35.69-6.1 14.79-4.44 23.3-4.8 37.73-4.8 37.73-10.73 52.51-10.36 54 10.91-16.46 10.72-25.33 8.88-36.62 10.18-38.28 10.18-49.2 10.18-49.2 7.21-20.16 11.83-26.81 10.36-19.23 12.76-21.45a24.22 24.22 0 0 1 5.73-3.7z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M741.5 140.8s-11.56-6.28-24.51 9.8c0 0-9.43 5.37-12.2 6.66s-5.92 35.69-5.92 35.69-6.1 14.79-4.44 23.3-4.8 37.73-4.8 37.73-10.73 52.51-10.36 54 10.91-16.46 10.73-25.33 8.87-36.62 10.17-38.28 10.17-49.19 10.17-49.19 7.21-20.16 11.83-26.81 10.36-19.23 12.76-21.45 6.84-3.7 6.84-3.7z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M690.78 256.38s-22-14.42-32.64-7.31-28 17.2-10.91 24.51 40.77 5.91 40.77 5.91z",
    fill: "#fec2be"
  }), React.createElement("path", {
    d: "M706.08 395.53c3.28 7 6 42.39 7.82 53.6 2.63-4.5 5.81-9.89 6.88-11.57 1.36-2.15 4.64-11.25 6.47-16.49-2.09-5.08-7.86-19.64-7.86-25 0-6.52-10.54-14.7-10.54-14.7s-6.66 5.84-2.77 14.16zM776.81 504.13s-24.41-10.41-31.62-3 31.62 3 31.62 3zM763.08 508.29s24.69 13.87 16.23 16.22-16.23-16.22-16.23-16.22zM689.3 496.22s10.54.69 6.51 2.77-6.51-2.77-6.51-2.77zM676.12 499.41c.14.69 30.65 10.54 24.69 15s-24.69-15-24.69-15zM773.2 584.29c-4.57-.69-30.09-12.48-20.11-4s20.11 4 20.11 4zM760.58 593.58s-2.22 8.6-10.68 7.49 10.68-7.49 10.68-7.49zM767.66 611.07c-1.53-.42-19.7-8.74-20.11-4.86s17.33 10.68 18.72 8.6a7.42 7.42 0 0 0 1.39-3.74zM708.85 601.07c-2.22-.14-23-6.79-27.18-.83zM689.99 604.95s-3.61-3.19-7.21-1.52 7.21 1.52 7.21 1.52zM736.03 639.35a6.18 6.18 0 0 1-4.71 4.85z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M630.21 652.39c1.39 5.68 20.81 6.24 30.1 4.71s28.57-7.03 28.57-7.03 20.25-1.94 26.21-4.44 1.25-8.88 1.25-8.88v-.59c.14-2.32.56-10.73-.87-13-1.67-2.63-.7-11.23-.7-11.23s-28.7 5.55-29.26 2.91-5-6.38-7.07-7.21-3.61 6.93-3.61 6.93-13 11.1-13.87 15.12-10 6.1-10 6.1-13.87 3.89-17.48 5.83a6.73 6.73 0 0 0-3.83 5.38 15.34 15.34 0 0 0 .56 5.4z",
    fill: "#ca8496"
  }), React.createElement("path", {
    d: "M630.21 652.39c1.39 5.68 20.81 6.24 30.1 4.71s28.57-7.03 28.57-7.03 20.25-1.94 26.21-4.44 1.25-8.88 1.25-8.88v-.59l-29 6.42s-14.28 6.1-23.43 6.1c-8 0-25.9 3.28-34.21-1.69a15.34 15.34 0 0 0 .51 5.4z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M669.5 630.47s1.39 9.16 6.94 12.21zM705.87 85.76a9 9 0 0 0 1.64.68c2.61.7 5.15-1.05 7.46-2.45s5.5-2.44 7.5-.63c2.61 2.37.72 7.44 3.41 9.72 1.7 1.45 4.4 1 6.29 2.15s2.46 3.79 2.94 6.05 1.43 4.82 3.64 5.48 4.25-.79 6.42-.71c.45 0 1 .07 1.28-.26a1.34 1.34 0 0 0 .21-1 21.39 21.39 0 0 1 .71-8c.89-2.55 3-4.87 5.63-5.28 3.9-.6 7.17 2.82 9.46 6a98.28 98.28 0 0 1 6.56 10.56 7.82 7.82 0 0 1 .33.73 33.5 33.5 0 0 0 2.88-13.66 33.84 33.84 0 0 0-66.36-9.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M762.5 96.95c-2.29-3.21-5.56-6.62-9.46-6-2.67.41-4.74 2.72-5.63 5.27a21.24 21.24 0 0 0-.7 8 1.38 1.38 0 0 1-.23 1c-.3.33-.82.28-1.27.26-2.17-.08-4.33 1.33-6.42.71s-3.16-3.22-3.64-5.48-1-4.82-2.94-6-4.59-.7-6.29-2.15c-2.69-2.29-.8-7.36-3.41-9.72-2-1.82-5.19-.78-7.5.62s-4.85 3.15-7.46 2.46c-.88-.24-1.67-.75-2.53-1.08-4.11-1.56-9.44 1.09-12.82-1.73a9.85 9.85 0 0 1-2.56-4.43 28.22 28.22 0 0 1-1.87-7.06 9.44 9.44 0 0 1 1.88-6.89c2.2-2.6 5.92-3.24 8.73-5.16 2.39-1.63 4-4.13 5.58-6.58s3.11-5 5.41-6.73 5.56-2.58 8.14-1.27a9.17 9.17 0 0 0 2.67 1.26 5.55 5.55 0 0 0 3-.81c9.62-4.53 20.82-3.73 31.37-2.38 4.22.54 8.5 1.18 12.35 3s7.25 5 8.33 9.13c.86 3.26.2 6.8 1.24 10 .7 2.18 2.14 4 3 6.19 2.25 5.84-.44 12.26-1.58 18.42-1.25 6.73-.62 14-3.48 20.39-.56 1.25-1.19 3.44-2.6 2.61-1-.61-2.06-4.16-2.66-5.26a97.3 97.3 0 0 0-6.65-10.59z",
    fill: "#9a5e7f"
  }), React.createElement("path", {
    d: "M823.36 205.34l5 14.24s-11.84 44-17.39 53.26-13.68 21.08-13.68 21.08-13.68 6.84-29.59 3.7-62.32-11.47-62.32-11.47-3.88.74-5.91-2.22-12.58-4.44-12.58-4.44-12.2-17.75 2.78-25.15c0 0 1.84 4.07 9.8 1.3s10.35 2.22 10.35 2.22 12.95 2.59 20.16 1.66 25.15-1.29 27-2.77a2.37 2.37 0 0 1 3.33.18s4.43-1.66 5.91-3.32 3.52 1.84 3.52 1.84 2.59-1.47 1.85-3.32 2.4-8.88 2.4-8.88 1.48-4.62.55-8.32 4.63-17 4.63-17a23.53 23.53 0 0 0-.74-6.66c-.93-3.33 7-10 7-10s7.77-37.72 24.23-25.33 13.7 29.4 13.7 29.4z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M824.5 205.34l5 14.24s-11.84 44-17.39 53.26-13.68 21.08-13.68 21.08-13.69 6.84-29.59 3.7-62.34-11.47-62.34-11.47-3.88.74-5.91-2.22-12.58-4.44-12.58-4.44-12.2-17.75 2.78-25.15c0 0 1.84 4.07 9.8 1.3s10.35 2.22 10.35 2.22 13 2.59 20.16 1.66 25.15-1.29 27-2.77a2.36 2.36 0 0 1 3.32.18s4.44-1.66 5.92-3.32 3.52 1.84 3.52 1.84 2.58-1.47 1.84-3.32 2.41-8.88 2.41-8.88 1.48-4.62.55-8.32 4.63-17 4.63-17a23.53 23.53 0 0 0-.74-6.66c-.93-3.33 7-10 7-10s7.77-37.72 24.23-25.33 13.72 29.4 13.72 29.4z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M704.27 264.89c.19 1.29 4.26 6.47 2.78 7.39s-3.89.37-1.67 3.33 2 7.4.56 6.84-3.88-7.21-3.88-9.8 2.21-7.76 2.21-7.76zM759.2 261.93s1.11 12.94 10.17 16.64-10.17-16.64-10.17-16.64zM778.06 257.49c.55.18 12.94 6.84 7.39 10.72s-7.39-10.72-7.39-10.72zM778.8 248.24s18.12 3.7 12 6.84-12-6.84-12-6.84z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M747.37 93.07c.89-2.55 3-4.86 5.63-5.27 3.9-.6 7.17 2.81 9.46 6a97.17 97.17 0 0 1 6.56 10.55c.6 1.11 1.62 4.66 2.66 5.27 1.41.83 2-1.37 2.6-2.62 2.86-6.36 2.23-13.65 3.48-20.38.73-3.93 2.08-8 2.38-11.89.42 4.83-1.47 9.92-2.38 14.85-1.25 6.73-.62 14-3.48 20.38-.56 1.25-1.19 3.44-2.6 2.62-1-.61-2.06-4.16-2.66-5.27a97.17 97.17 0 0 0-6.52-10.54c-2.29-3.22-5.56-6.62-9.46-6-2.67.41-4.74 2.72-5.63 5.27a14.67 14.67 0 0 0-.74 4.16 19.13 19.13 0 0 1 .7-7.13zM689.6 75.51a9.91 9.91 0 0 0 2.56 4.43c3.38 2.82 8.71.16 12.82 1.73a25.2 25.2 0 0 0 2.53 1.07c2.61.7 5.15-1 7.46-2.45s5.5-2.44 7.5-.63c2.61 2.37.72 7.44 3.41 9.72 1.7 1.46 4.4 1 6.29 2.15s2.46 3.79 2.94 6 1.43 4.82 3.64 5.48 4.25-.79 6.42-.71c.45 0 1 .07 1.27-.26a.74.74 0 0 0 .16-.27c0 .74 0 1.48.07 2.22a1.4 1.4 0 0 1-.23 1c-.3.33-.82.28-1.27.26-2.17-.08-4.33 1.33-6.42.71s-3.16-3.23-3.64-5.48-1-4.82-2.94-6.05-4.59-.7-6.29-2.15c-2.69-2.28-.8-7.35-3.41-9.72-2-1.81-5.19-.77-7.5.63s-4.85 3.15-7.46 2.45c-.88-.24-1.67-.74-2.53-1.07-4.11-1.57-9.44 1.09-12.82-1.73a9.89 9.89 0 0 1-2.56-4.44 28 28 0 0 1-1.87-7.06 11.43 11.43 0 0 1 .06-2.48 30 30 0 0 0 1.81 6.65z"
  })), React.createElement("path", {
    d: "M233.56 563.2c0 62.42 36.23 113 80.92 113s80.92-50.6 80.92-113-36.23-113-80.92-113-80.92 50.59-80.92 113zm5.58-1.51c0-54.64 31.86-98.94 71.15-98.94s71.21 44.32 71.21 98.94-31.86 98.94-71.16 98.94-71.2-44.3-71.2-98.94z",
    fill: "#35323e"
  }), React.createElement("path", {
    d: "M304.71 316.25l5.58 94.88h109.66a38 38 0 0 1 25.78 9.75 34.36 34.36 0 0 1 11.06 22.34v142.31h-14l.1-9.77H304.66v-14h138.42l1.14-114.18a18.54 18.54 0 0 0-.44-4.27c-.86-3.76-3.27-10.62-9.72-14.47a18.12 18.12 0 0 0-9.3-2.42H300.5l-7-99.06h-41.8v-11.11z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M304.71 316.25l5.58 94.88h109.66a38 38 0 0 1 25.78 9.75 34.36 34.36 0 0 1 11.06 22.34v142.31h-14l.1-9.77H304.66v-14h138.42l1.14-114.18a18.54 18.54 0 0 0-.44-4.27c-.86-3.76-3.27-10.62-9.72-14.47a18.12 18.12 0 0 0-9.3-2.42H300.5l-7-99.06h-41.8v-11.11z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#35323e",
    d: "M301.23 367.17l-105.34-3.48 5.58 146.49L454 512.97l-6.28-59.29-137.43 23.02-9.06-109.53z"
  }), React.createElement("path", {
    fill: "#464353",
    d: "M205.65 561.8h139.52v13.95H205.65z"
  }), React.createElement("path", {
    d: "M300.5 551.23v-41h11.16v41c4.13 3.09 7 9.47 7 16.86 0 10.4-5.63 18.83-12.56 18.83s-12.56-8.43-12.56-18.83c.01-7.39 2.86-13.77 6.96-16.86zM355.35 586.14a13.12 13.12 0 0 0-17.15-.61s-16.74 11.16-1.4 58.6c0 0 11.17 7 5.58-15.35s-2.79-36.28 2.79-36.28 12.56 15.35 12.56 15.35l9.77-4.18s-4.41-10.29-12.15-17.53zM459.99 586.14a13.12 13.12 0 0 0-17.15-.61s-16.74 11.16-1.4 58.6c0 0 11.17 7 5.59-15.35s-2.8-36.28 2.79-36.28 12.55 15.35 12.55 15.35l9.77-4.18s-4.41-10.29-12.15-17.53z",
    fill: "#464353"
  }), React.createElement("ellipse", {
    cx: 458.88,
    cy: 639.94,
    rx: 31.39,
    ry: 41.86,
    fill: "#35323e"
  }), React.createElement("ellipse", {
    cx: 354.24,
    cy: 639.94,
    rx: 31.39,
    ry: 41.86,
    fill: "#35323e"
  }), React.createElement("path", {
    d: "M582 721c-3.23-3.29-8.15-5.73-11.12-5.73-6.25 0-30.89-29.24-32.53-33.38-.6-1.51-1.6-1-2.62.33-2-4.73-4.62-11.39-5.32-16.15 2.64-.67 4.33-1.16 4.33-1.16s.32-9.42-2-10.4h-.06c-2.24-1.32-2.24-20.75-2.24-20.75s-5.25-17.17-4.59-23.37S512.74 557 512.74 557s-3.61-28.37-10.18-31.24c-5.55-2.43-52.3-15.77-66.74-19.87-.31-.7-2.55-5.1-9.81-5.1-7.89 0-31.54.33-39.42-8.77a18.23 18.23 0 0 1-2.43-3.94c3.9-7.17 4.15-19 2.75-21.73-2-3.9-3.28-11.7-3.28-11.7s-1-18.84-2.32-23.72-6.88-44.84-6.88-44.84-11.17-10.65-19.06-12.95a33 33 0 0 1-9.55-5c.12-.65.24-1.24.33-1.74a29.53 29.53 0 0 0 10-16.74 4.71 4.71 0 0 0 .32-1.11 11.27 11.27 0 0 0 .08-1.54c.1-.94.16-1.89.17-2.85v-.29-.33a3.81 3.81 0 0 1 .55-1.3c1.15-1.65 3.52-2 5.41-2.82a8.21 8.21 0 0 0 .83-.44l.24-.16c.18-.11.35-.22.51-.34l.28-.23.41-.35.27-.27c.12-.12.24-.24.35-.37l.26-.31c.1-.13.2-.25.29-.38l.24-.35a4 4 0 0 0 .24-.38c.08-.13.16-.26.23-.4s.13-.25.19-.37.15-.3.21-.45a3.45 3.45 0 0 0 .14-.34c.07-.17.14-.34.2-.51l.09-.27c.06-.2.13-.4.19-.61v-.06a15.63 15.63 0 0 0 .46-5.19c0-.44-.08-.87-.15-1.3-.49-3-1.57-6.09-1.21-9.05 0-.26.08-.52.13-.78v-.09a7.94 7.94 0 0 1 .22-.8c.41-1.19 1.11-2.28 1.49-3.47a6.87 6.87 0 0 0 .19-.75v-.2c0-.21.06-.42.07-.63v-.15a7.59 7.59 0 0 0-.11-1.64 10.73 10.73 0 0 0-3.57-6c-2.71-2.38-6.26-3.69-9.75-4.84-9-3-18.37-5.84-27.9-6.45-4.18-.27-9.65-1.56-13 1-3.91 3-6.35 5.25-11.21 7.29-3.51 1.47-7.17 3.73-8 7.28a28 28 0 0 0-.17 4.76c-.16 3.2-1.7 6.18-2.69 9.24a14 14 0 0 0-.74 5.58v.09c0 .22.06.44.1.65v.11a7.46 7.46 0 0 0 .43 1.39c0 .06.05.11.07.17s.16.33.25.49l.09.17c.13.21.26.41.41.61.61.81 1.43 1.49 2 2.34a9.58 9.58 0 0 1 1.14 4.31c.16 1.52.31 3.05.47 4.57v.34c-.05.67-.08 1.35-.08 2a30.31 30.31 0 0 0 .38 4.7c-3.33 2.51-6.76 5.52-7.47 7.72a3.73 3.73 0 0 0-.79 2.2c-3.13 2.45-16.43 1-16.43 1s-10.84 5.85-14.78 3.57-27.6 15.92-27.6 15.92-6.24.33-6.57 2.93c0 0-7.88 5.85-13.8 5.85s-9.53 7.47-9.53 7.47-9.85 4.55-13.14 5.2-8.87 3.9-7.22 5.2-.33 4.22-3.29 6.5-7.56 14-3.61 15.59 14.78 4.88 17.74 6.5a6.41 6.41 0 0 0 3.68.69 9.41 9.41 0 0 0 4.2-.69l.46-.57c3.86 2.93 8.89 5.94 13.73 6.42 7.62.76 24 3.88 30.94 5.23v1.29c-.06 12.14.51 24.72 2.85 28.57 4.93 8.13 5.58 71.81 5.58 71.81s15.44 2.28 20.7 7.15c5 4.6 30.18 13 35.15 2.09l1.58.68c12.8 5.55 29.79 13.45 31.74 17 3.15 5.85 25.82 15.6 25.82 15.6s14.79.32 10.51 14S406 649.92 406 649.92a9 9 0 0 0 1.88 5.73 9.35 9.35 0 0 0 1.4 1.42c1.31 1 5.39 2.83 10.12 3.64 1.21 2.72 2.17 5.08 2 5.46s1.42 1.79 3.51 3.63a74.26 74.26 0 0 0 5.65 10.31 8.52 8.52 0 0 0 2.93 2.95c3.2 1.3 36.54 21.12 42.79 21.77 5.81.61 17.61 3.46 28.23-4.81l-1.71 13.86-.57 4.6s16.76 6.82 23.66 6.82 30.22 11.05 30.22 11.05 15.44 3.25 25.63-3.57c5.33-3.57 3.82-8.21.26-11.78zM476 570.32c-1.65 3.57-.58 10.07.2 10.07s4.4 5.2 2.43 11.05 12.81 59.13 19.38 66.28c0 0 0 .18-.12.49-.48 2.17-1.86 11 7.35 11.53h1.05c.7 5.56 1.75 14.31 2.39 21.57-1.48-4.31-7.19-8.68-12.89-12.12a113.78 113.78 0 0 0-13.22-6.74s-18.4-4.38-22.34-8-15.69-10.11-15.69-10.11c-1.85-1.67-3.93-3.55-5.89-5.35.11-.76.18-1.56.22-2.41a38.52 38.52 0 0 0-1.74-5c-.77-1.75-1.76-3.45-2.86-4.14-2.62-1.62-11.5-35.09-11.5-39s-5.58-22.42-7.55-25.67-4.27-11.4-4.27-11.4 29.89 4.58 57.82 2c-.05.12 8.82 3.37 7.23 6.95zM244.66 420.2v.38l-1.74-.43c1.08.05 1.74.05 1.74.05zm94.84-49.59v1.81l-.34-.35c-.28-.31-.54-.63-.81-.95.39-.12.77-.33 1.15-.51zM371.65 439c-.33-1.91-.51-3-.51-3l.12-1.83zm-152-23.07a9.56 9.56 0 0 1 2.14-.46 5.3 5.3 0 0 1 1.83.5c.77.36 1.57.7 2.38 1l-5.73-1a3.18 3.18 0 0 0-.61-.03z",
    transform: "translate(-40.5 -83.93)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M373.67 566.66s6.6 13.66 6.28 14.63 14.18 12.57 14.18 12.57l15.8-11.28-1.61-7.74s-17.73-16-19-17.83-15.65 9.65-15.65 9.65z",
    fill: "#a1616a"
  }), React.createElement("path", {
    d: "M463.78 612.89c-11 10.64-23.86 7.41-30 6.77s-38.85-20.32-42-21.61a8.32 8.32 0 0 1-2.87-2.92 75.41 75.41 0 0 1-5.54-10.24c.22.06 10.95 3.12 13.66 0 0 0 4.51-5.54 5.48-5.54s.07-9.71.07-9.71 11.54 6.49 15.41 10 21.92 7.9 21.92 7.9a111.32 111.32 0 0 1 13 6.69c8.59 5.25 17.11 12.61 10.87 18.66z",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M463.78 612.89c-11 10.64-23.86 7.41-30 6.77s-38.85-20.32-42-21.61a8.32 8.32 0 0 1-2.87-2.92c3.82-2.28 28.74 13.57 35.72 16.47s24.62 1.29 34.62-2.9c5-2.09-.07-8.52-6.37-14.44 8.62 5.22 17.14 12.58 10.9 18.63z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M462.5 579.35s4.6 34.5 3.43 39 28.82-15.48 28.82-15.48-10.49-21.62-7.42-26.59-24.83 3.07-24.83 3.07z",
    fill: "#a1616a"
  }), React.createElement("path", {
    d: "M491.19 580s-18.7 5.48-29 4.83c-9-.56-7.69-9.28-7.21-11.44.07-.31.12-.49.12-.49-6.45-7.09-21-60-19-65.78s-1.61-11-2.38-11-1.81-6.45-.2-10-7.09-6.77-7.09-6.77c-27.41 2.58-56.75-2-56.75-2s2.25 8.1 4.19 11.32 7.42 21.61 7.42 25.48 8.7 37.08 11.28 38.69c1.08.68 2.05 2.37 2.81 4.1a39.14 39.14 0 0 1 1.71 4.93c-1 21.6-25.48 13.22-29 10.32a8.84 8.84 0 0 1-3.22-7.1s-32-32.49-27.81-46.02-10.32-13.86-10.32-13.86-22.24-9.7-25.34-15.5c-1.91-3.57-18.6-11.41-31.16-16.92-7.87-3.45-14.12-6-14.12-6l5.23-18.72 4.15-14.79 7.76-2.92 24.78-9.29 44.55-6.13 4.08.53 43.27 5.6s63.2 18.05 69.65 20.9 10 31 10 31 13.54 46.76 12.9 52.91 4.51 23.19 4.51 23.19 0 19.29 2.19 20.6h.07c2.24.98 1.93 10.33 1.93 10.33z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M426.38 479.39c-27.41 2.58-56.75-2-56.75-2-1.94-6.09-29-22.86-29-22.86 22.19-5.46 85.75 24.86 85.75 24.86z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M397.04 561.94c-1 21.6-25.48 13.22-29 10.32a9.05 9.05 0 0 1-1.37-1.41c8.57 3.16 23.75 5.59 28.69-13.84a39.14 39.14 0 0 1 1.68 4.93zM491.19 580s-18.7 5.48-29 4.83c-9-.56-7.69-9.28-7.21-11.44 9.47-.3 25.77-1.19 34.23-3.75h.07c2.22 1.01 1.91 10.36 1.91 10.36z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M397.04 561.94c-1 21.6-25.48 13.22-29 10.32a9.05 9.05 0 0 1-1.37-1.41c8.57 3.16 23.75 5.59 28.69-13.84a39.14 39.14 0 0 1 1.68 4.93zM491.19 580s-18.7 5.48-29 4.83c-9-.56-7.69-9.28-7.21-11.44 9.47-.3 25.77-1.19 34.23-3.75h.07c2.22 1.01 1.91 10.36 1.91 10.36z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M537.3 647.39c-10 6.77-25.15 3.55-25.15 3.55s-22.89-11-29.66-11-23.22-6.77-23.22-6.77l.55-4.56 2.68-21.85s25.12-.64 26.12-2.9c0 0 4.52-11.11 6.13-7s25.8 33.13 31.92 33.13c2.92 0 7.75 2.42 10.92 5.68 3.47 3.57 4.91 8.18-.29 11.72z",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M450.56 456.82s-21 13.22-15.15 16.12 15.15-16.12 15.15-16.12zM459.27 482.29s-18.06 17.15-11.29 17.6 11.29-17.6 11.29-17.6zM478.62 536.79s-9.12 17.28-5.72 20.22 5.72-20.22 5.72-20.22zM377.69 554.2c3.22 3.23-30.64-10.64-22.9-11.29s22.9 11.29 22.9 11.29z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M309.97 312.36l-1.07-.16c-4-.62-18.55-2.9-31.59-5.73-3.18-.69-6.26-1.41-9.09-2.15-10-2.62-16.69-5.45-12.42-7.76 5.66-3.07 8.64-8.65 10.21-13.45q.23-.71.42-1.38a35.57 35.57 0 0 0 1.3-7.42s36.44-12.9 29.34 0c-3.48 6.33-1.14 11.49 2.15 15.11a28.33 28.33 0 0 0 7.85 5.85z",
    fill: "#a1616a"
  }), React.createElement("path", {
    d: "M270.96 302.36s13 9.35 26.34 1.61 30.73 68.37 30.73 68.37l18.06 44.49s11.7 9.68-2.86 13.87-46.85-4.19-55.05 8.06-23.68 14.19-25.31 14.19-7.73-46.11-7.73-46.11l-1.64-66.77z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M342.59 428.12c-14.56 4.19-46.86-4.19-55 8.06a31.56 31.56 0 0 1-13.88 11.17 36.46 36.46 0 0 1-11.44 3c-.21 0-.51-.85-.87-2.31-2.27-9.33-6.86-43.8-6.86-43.8l-1.59-66.75 15.32-33.19 2.09-4.54a27.58 27.58 0 0 0 6.64 3.23 23.4 23.4 0 0 0 19.71-1.61c3.91-2.27 8.17 2.67 12.24 10.8 9.79 19.56 18.48 57.56 18.48 57.56l18.06 44.49a15.69 15.69 0 0 1 1.23 1.18c2.51 2.72 7.32 9.41-4.13 12.71z",
    fill: "#f3f5f9"
  }), React.createElement("path", {
    d: "M273.23 430.36a84 84 0 0 1 .43 17 197.72 197.72 0 0 1-3 24 8 8 0 0 1-.39 1.46c-7.87-3.45-14.12-6-14.12-6l5.2-18.75c-2.27-9.33-6.86-43.8-6.86-43.8l-1.59-66.75 15.32-33.19c-10-2.62-16.69-5.45-12.42-7.76 6.2-3.37 9.19-9.76 10.63-14.83a54.11 54.11 0 0 0 9.16 9.86l.2.17 1.16 11.25.36 3.46.74 7.18s-3.55 84.8-6.13 89.64-1.29 14.19 1 25.15c.1.62.21 1.25.31 1.91z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M271.6 427.15c2.26 11 .32 29-2.26 42.89s-30 4.84-35.14 0-20.32-7.09-20.32-7.09-.64-63.21-5.48-71.27c-2.3-3.82-2.85-16.3-2.79-28.35 0-10.83.58-21.31.78-24.87.05-.82.07-1.27.07-1.27s-21-35.47-20.63-38.05 6.45-2.9 6.45-2.9 23.21-18.06 27.08-15.8 14.51-3.55 14.51-3.55 13.49 1.53 16.27-1.07a1.42 1.42 0 0 0 .5-1.19c-.32-4.13 13.74-12.94 14.18-13.21-11.85 10.66 7.31 27.08 9.48 28.88l.2.17 2.26 21.89s-3.55 84.8-6.13 89.64-1.29 14.19.97 25.15z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 270.35,
    cy: 335.03,
    r: 1.61,
    fill: "#444053"
  }), React.createElement("path", {
    d: "M273.66 291.59l-9.8 9.48-14.36-24a1.45 1.45 0 0 0 .5-1.19c-.32-4.13 13.74-12.94 14.17-13.21-11.85 10.7 7.33 27.12 9.49 28.92z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 267.13,
    cy: 386.62,
    r: 1.61,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 267.13,
    cy: 385.97,
    r: 1.61,
    fill: "#444053"
  }), React.createElement("path", {
    d: "M274.3 290.3l-9.8 9.48-14.37-24a1.42 1.42 0 0 0 .5-1.19c-.32-4.13 13.74-12.94 14.18-13.21-11.84 10.69 7.32 27.12 9.49 28.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M393.5 424.25c-8.06 3.55-60.95-5.8-68.68-8.06s-19-19.67-13.55-32.25-1.94-24.87-1.94-24.87-11.61-24.82-14.19-29.66-8-18.92-8.71-21.28a2 2 0 0 1 .46-1.48c2.1-3.19 10.18-8.84 10.18-8.84 2.28.82 2.56-5.7 2.47-10.49-.05-2.68-.21-4.82-.21-4.82s1.07 1.09 2.82 2.57c.64.54 1.37 1.13 2.17 1.74a33.61 33.61 0 0 0 10.18 5.6c7.74 2.28 18.7 12.85 18.7 12.85l-3.23 49.53s7.42 46.57 15.16 55.6 31 8.7 38.69 8.7 9.68 5.16 9.68 5.16z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M394.13 422.32c-8.06 3.54-60.94-5.81-68.68-8.07s-19-19.67-13.54-32.24-1.94-24.83-1.94-24.83-11.61-24.83-14.19-29.67-7.95-18.92-8.7-21.28a1.86 1.86 0 0 1 .46-1.47c2.09-3.2 10.18-8.85 10.18-8.85 2.28.83 2.56-5.69 2.47-10.48-.05-2.69-.21-4.83-.21-4.83s1.07 1.09 2.81 2.58c.64.53 1.37 1.13 2.18 1.74a33.32 33.32 0 0 0 10.16 5.55c7.74 2.29 18.7 12.86 18.7 12.86l-3.22 49.52s7.42 46.57 15.15 55.6 31 8.71 38.7 8.71 9.67 5.16 9.67 5.16z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M306.43 281.89s-.31 1.71-.82 4.32c-1.73 8.85-5.87 28.19-8.86 27.44-2.14-.54-5.76-4.33-8.57-7.6 2.1-3.2 10.18-8.85 10.18-8.85 2.28.83 2.56-5.69 2.47-10.48l2.61-2.25z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M305.78 280.6s-.3 1.71-.81 4.32c-1.74 8.85-5.88 28.19-8.86 27.44-2.14-.54-5.76-4.33-8.57-7.6 2.09-3.2 10.18-8.85 10.18-8.85 2.28.83 2.56-5.69 2.47-10.48l2.6-2.25z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#f86d70",
    d: "M304.46 329.83v32.72L295.81 380l-.27.55-22.9-1.51-8.8-.59-20.43-1.35v-39.13l20.43.58 9.14.26 23.1.65 8.38-9.63z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M304.46 331.76v30.79l-2.11 4.26-2.17 4.37-4.37 8.82.49-32.72.1-6.6 4.15-4.59v-.01l1.81-2 2.1-2.32z"
  }), React.createElement("path", {
    fill: "#f86d70",
    d: "M305.63 321.15v11.42l-1.17 1.87-2.1 3.35-1.86 2.96-4.1 6.54-.1-.01-54.68-2.81V333.2l.13-.15 6.53-7.07 2.37-2.55 4.27-4.63 50.71 2.35z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M296.4 336.02v11.27l-54.78-2.82V333.2l.13-.15 54.65 2.97z"
  }), React.createElement("path", {
    opacity: 0.15,
    d: "M305.63 321.15v11.42l-9.23 14.72v-11.27l9.23-14.87z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M302.37 326.4l-.01 7.68v3.71l-.01 29.02-2.17 4.37.32-30.43.05-4.66v-.01l.08-6.87-52.35-3.23 2.37-2.55 51.72 2.97z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M276.68 326.78l-3.67 7.97-.03 4.06-.34 40.23-8.8-.59v-44.23l4.7-7.44h8.14z"
  }), React.createElement("path", {
    d: "M264.6 327.32a11.54 11.54 0 0 1-6.56.23 2.59 2.59 0 0 1-1.15-.53 2.91 2.91 0 0 1-.71-1.41 10.92 10.92 0 0 1-.63-3.38 3.72 3.72 0 0 1 1.4-3 3.51 3.51 0 0 0 .53-.4 2.15 2.15 0 0 0 .42-.84c.64-1.91 1.88-3.93 3.87-4.24s3.52 1 4.94 2.21l3.11 2.65a4.91 4.91 0 0 1 9.15-.13 17.34 17.34 0 0 1 6.92-4.74 2.16 2.16 0 0 1 1.82-.08 2.22 2.22 0 0 1 .73 1 15 15 0 0 1 1.34 5.9 1 1 0 0 1 1.2.42 2.65 2.65 0 0 1 .4 1.3 17 17 0 0 1 .13 2.14 3.19 3.19 0 0 1-.57 2.14 3.53 3.53 0 0 1-2.7.84 1.09 1.09 0 0 1-.28 1.61 3.13 3.13 0 0 1-1.82.36c-2.42 0-5-.1-7-1.44-.8-.53-1.46-1.24-2.26-1.76-1.95-1.3-4.41-1.36-6.67-1.25-2.05.05-3.71 1.75-5.61 2.4z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M264.15 326.79s-20.19 2.81-23 15l4.22-.62 3 5.32s3.13-11.9 12.36-14.72 12.52-3.28 12.52-3.28 6.42 1.56 12.21 20.19l3.29-4.54 5.79 1.25s-4.23-14.56-15.65-18.62z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M326.42 375.56s-16.13-3.22-20.64-10.32-35.22-13.22-31.48-5.8 31.48 31.68 31.48 31.68l12 17.21 16-4.07 6.76-13.14z",
    fill: "#a1616a"
  }), React.createElement("path", {
    d: "M288.27 393.96s15.62 5.8 18 13.54-18-13.54-18-13.54zM278.69 402.97s-1.42 8.06 18.16 7.41zM194.21 299.78l-7.09-.64s-7.74 5.8-13.55 5.8-9.35 7.42-9.35 7.42-9.67 4.51-12.9 5.16-8.7 3.87-7.09 5.16-.32 4.19-3.22 6.45-7.42 13.86-3.55 15.47 14.51 4.84 17.41 6.45 6.45 0 6.45 0S178.4 328.8 187.11 333s20.64 4.19 20.64 4.19l9.36-19.67z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M342.59 405.88a8.62 8.62 0 0 1-6 4.18 45.57 45.57 0 0 1-18.77-1.73s32.48-10.32 1.2-35.41h8.38l2.8-1.06-1.28-6.68-1.84-60.24 6.77-1.61s5.45 39.66 6.76 44.5 2.27 23.54 2.27 23.54 1.29 7.74 3.23 11.61c1.39 2.91 1.06 16.02-3.52 22.9z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M341.3 405.88a8.63 8.63 0 0 1-6 4.18 45.6 45.6 0 0 1-18.8-1.73s32.48-10.32 1.2-35.41h8.39l2.79-1.06c4.62 8.13 11.83 22.6 12.42 34.02z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M342.59 405.88a8.62 8.62 0 0 1-6 4.18 45.57 45.57 0 0 1-18.77-1.73s32.48-10.32 1.2-35.41h8.38l2.8-1.06c4.57 8.13 11.8 22.6 12.39 34.02z",
    fill: "none"
  }), React.createElement("path", {
    d: "M342.59 405.88a8.62 8.62 0 0 1-6 4.18 45.57 45.57 0 0 1-18.77-1.73s32.48-10.32 1.2-35.41h8.38l2.8-1.06c4.57 8.13 11.8 22.6 12.39 34.02z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M299.22 289.42a29.36 29.36 0 0 1-33.21-6.35q.23-.71.42-1.38a35.57 35.57 0 0 0 1.3-7.42s36.44-12.9 29.34 0c-3.48 6.37-1.14 11.53 2.15 15.15z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M316.42 261.41v.28c0 1-.06 1.9-.16 2.83s-.23 1.77-.4 2.64a29.36 29.36 0 0 1-56.54 3.79c-.19-.57-.37-1.14-.53-1.72a29.23 29.23 0 0 1-1.06-7.82c0-.68 0-1.35.08-2a29.34 29.34 0 0 1 58.61 2z",
    fill: "#a1616a"
  }), React.createElement("path", {
    d: "M316.42 261.69a13.15 13.15 0 0 0-.16 2.83 11.12 11.12 0 0 1-.08 1.53 4.4 4.4 0 0 1-.32 1.11c-1.19 2.78-5.06 4.58-7.61 2.79a8.26 8.26 0 0 1-2.29-3c-2.71-5-6.48-10.83-12.41-10.93-2.53-.05-4.91 1-7.36 1.64s-5.34.7-7.17-1c-1.4-1.28-2.06-3.47-3.94-3.92s-3.62 1.28-4.48 3-1.55 3.67-3.29 4.55c-.78.38-1.69.49-2.45.9-3.51 1.93-1.9 8.66-5.54 9.75l-.35.08-.18-1.8-1-9.84a29.34 29.34 0 0 1 58.61 2z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M264.29 217.61c-3.44 1.46-7 3.71-7.81 7.23a28.55 28.55 0 0 0-.16 4.72c-.16 3.18-1.68 6.13-2.64 9.17s-1.32 6.6.62 9.19c.61.81 1.41 1.48 1.95 2.33a9.5 9.5 0 0 1 1.13 4.27l1.59 15.87c4.1-.76 2.27-7.85 5.89-9.83.76-.41 1.67-.53 2.45-.91 1.74-.87 2.42-2.86 3.29-4.55s2.57-3.42 4.48-3 2.54 2.64 3.94 3.91c1.83 1.67 4.74 1.59 7.18 1s4.82-1.69 7.35-1.65c5.93.1 9.7 5.9 12.41 10.93a8.38 8.38 0 0 0 2.29 3c2.88 2 7.43-.53 7.93-3.91.27-1.89-.32-4 .78-5.61s3.45-2 5.3-2.8c4.71-2.17 6.17-8.05 5.39-13-.57-3.55-2-7.22-.82-10.64.4-1.18 1.09-2.26 1.46-3.44 1-3.32-.66-7-3.32-9.34s-6.14-3.66-9.56-4.81c-8.8-2.94-18-5.79-27.39-6.4-4.1-.26-9.47-1.54-12.72 1-3.8 3.04-6.24 5.25-11.01 7.27z",
    fill: "#464353"
  }), React.createElement("circle", {
    cx: 271.96,
    cy: 309.55,
    r: 1.61,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 271.96,
    cy: 308.91,
    r: 1.61,
    fill: "#444053"
  }), React.createElement("circle", {
    cx: 261.65,
    cy: 410.8,
    r: 1.61,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 261.65,
    cy: 410.16,
    r: 1.61,
    fill: "#444053"
  }), React.createElement("circle", {
    cx: 267.13,
    cy: 437.57,
    r: 1.61,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 267.13,
    cy: 436.92,
    r: 1.61,
    fill: "#444053"
  }), React.createElement("path", {
    d: "M322.55 335.07s3.55 24.08 0 28.28 0-28.28 0-28.28zM217.11 379.75s-6.78 14.59 0 28.58 11 19.67 8.7 28.6-8.7-57.18-8.7-57.18zM537.3 647.39c-10 6.77-25.15 3.55-25.15 3.55s-22.89-11-29.66-11-23.22-6.77-23.22-6.77l.55-4.56c6.69 1.29 21.88 4.35 23.63 5.85 2.26 1.94 30 11.29 30 11.29s18.88-2.36 24.14-10.12c3.47 3.61 4.91 8.22-.29 11.76z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M256.32 226.99v-1.06 1.21a.77.77 0 0 0 0-.15zM322.26 254.41c-1.85.86-4.18 1.16-5.3 2.8s-.51 3.72-.78 5.61c-.5 3.38-5.05 5.93-7.93 3.91a8.3 8.3 0 0 1-2.29-3c-2.71-5-6.48-10.83-12.41-10.93-2.53 0-4.91 1-7.35 1.65s-5.35.7-7.18-1c-1.4-1.27-2.06-3.46-3.94-3.91s-3.61 1.27-4.48 3-1.55 3.68-3.29 4.55c-.78.38-1.69.5-2.45.91-3.61 2-1.79 9.07-5.89 9.83l-1.59-15.87a9.5 9.5 0 0 0-1.13-4.27c-.54-.85-1.34-1.52-1.95-2.33a7.17 7.17 0 0 1-1.32-3.41 8.27 8.27 0 0 0 1.32 6c.61.81 1.41 1.48 1.95 2.33a9.5 9.5 0 0 1 1.13 4.27l1.59 15.87c4.1-.76 2.28-7.85 5.89-9.83.76-.41 1.67-.53 2.45-.91 1.74-.87 2.43-2.86 3.29-4.55s2.57-3.42 4.48-3 2.54 2.64 3.94 3.91c1.83 1.67 4.74 1.59 7.18 1s4.82-1.69 7.35-1.65c5.93.1 9.7 5.9 12.41 10.93a8.38 8.38 0 0 0 2.29 3c2.88 2 7.43-.53 7.93-3.91.27-1.89-.32-4 .78-5.61s3.45-2 5.3-2.8c4.31-2 5.89-7.07 5.53-11.7-.29 3.77-2.01 7.49-5.53 9.11zM328.29 227.34c-.37 1.18-1.06 2.26-1.46 3.44a10 10 0 0 0-.33 4.29 8.1 8.1 0 0 1 .37-1.66c.4-1.18 1.09-2.26 1.46-3.44a7.27 7.27 0 0 0 .19-3.37 7.55 7.55 0 0 1-.23.74z"
  })), React.createElement("path", {
    d: "M233.55 370.71c-7.42-1.62-24.83-6.76-24.83-6.76l-3.11-.62c0-10.83.58-21.31.78-24.87h.07s14.84 4.83 18.38 7.41 14.51 1.94 14.51 1.94 17.09 1 31.28 16.77-29.66 7.76-37.08 6.13z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M161.07 341.93a4.3 4.3 0 0 0-1 7.23c3.92 3.25 9.66 7.15 15.13 7.7 9.14.92 31.12 5.33 33.31 5.77l.34.08c1.81.53 17.67 5.18 24.66 6.71 7.42 1.63 51.27 9.69 37.08-6.11-13.06-14.55-28.57-16.52-31-16.75a5.42 5.42 0 0 0-.57 0c-1.66.08-11 .4-14.26-2a30.62 30.62 0 0 0-5.33-2.65 102 102 0 0 0-21.8-6.29l-15.13-2.55a4.38 4.38 0 0 0-2.55.32z",
    fill: "#a1616a"
  }), React.createElement("path", {
    d: "M192.92 299.78l-7.09-.64s-7.74 5.8-13.55 5.8-9.35 7.42-9.35 7.42-9.67 4.51-12.9 5.16-8.7 3.87-7.09 5.16-.32 4.19-3.22 6.45-7.42 13.86-3.55 15.47 14.51 4.84 17.41 6.45 6.45 0 6.45 0 17.08-22.25 25.79-18.05 20.68 4.19 20.68 4.19l9.36-19.67z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M208.44 418.07v83.71h133.94v14H209.84v60h-14V418.07z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M147.05 316.25h53l5.58 94.88h109.68a38 38 0 0 1 25.78 9.75 34.36 34.36 0 0 1 11.06 22.34v142.31H338.2l1.38-137.9a18.54 18.54 0 0 0-.44-4.27c-.86-3.76-3.27-10.62-9.72-14.47a18.12 18.12 0 0 0-9.3-2.42H195.89l-7-99.06h-41.84z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M128.92 563.2c0 62.42 36.23 113 80.92 113s80.92-50.6 80.92-113-36.23-113-80.92-113-80.92 50.59-80.92 113zm5.58-1.51c0-54.64 31.86-98.94 71.15-98.94s71.16 44.3 71.16 98.94-31.86 98.94-71.16 98.94-71.15-44.3-71.15-98.94z",
    fill: "#35323e"
  }), React.createElement("ellipse", {
    cx: 201.47,
    cy: 566.69,
    rx: 12.56,
    ry: 18.84,
    fill: "#35323e"
  }), React.createElement("ellipse", {
    cx: 198.68,
    cy: 567.39,
    rx: 2.79,
    ry: 5.58,
    fill: "#464353"
  }), React.createElement("path", {
    d: "M349.36 539.49v15.34c4.38-2.73 9.19-2 13.44-.16a25.34 25.34 0 0 1 13.93 16.4c3.38 11.7 10 34.72 15.88 56.36 8.37 30.64 23.72 23.64 23.72 23.64l106.73 7.68 45.35-23v-14H454s-26.51 9.77-37.67 14-7-4.19-21.71-56.83-45.26-39.43-45.26-39.43z",
    fill: "#464353"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M416.33 651.1l106.73 7.67 45.35-23.02-111.62-1.39-40.46 16.74z"
  }), React.createElement("ellipse", {
    cx: 1025.08,
    cy: 635.11,
    rx: 59.47,
    ry: 11.44,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 1024.09,
    cy: 630.25,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 1024.09,
    cy: 619.17,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 1024.09,
    cy: 608.1,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 1024.09,
    cy: 597.02,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 1024.09,
    cy: 585.94,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 1024.09,
    cy: 574.86,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 1024.09,
    cy: 563.78,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M1050.01 487.98a34.28 34.28 0 0 0 2.58-3.8l-18.2-3 19.68.14a33.25 33.25 0 0 0 .63-26.27l-26.39 13.69 24.34-17.9a33.17 33.17 0 1 0-54.78 37.12 33.57 33.57 0 0 0-3.78 6.05l23.62 12.27-25.21-8.43a33.19 33.19 0 0 0 5.34 31.14 33.16 33.16 0 1 0 52.14 0 33.2 33.2 0 0 0 0-41z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M990.78 508.48a33 33 0 0 0 7.09 20.51 33.16 33.16 0 1 0 52.14 0c4.49-5.64-59.23-24.23-59.23-20.51z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 93.08,
    cy: 637.57,
    rx: 40.92,
    ry: 7.87,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 92.4,
    cy: 634.23,
    rx: 4.76,
    ry: 6.24,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 92.4,
    cy: 626.61,
    rx: 4.76,
    ry: 6.24,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 92.4,
    cy: 618.99,
    rx: 4.76,
    ry: 6.24,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 92.4,
    cy: 611.36,
    rx: 4.76,
    ry: 6.24,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 92.4,
    cy: 603.74,
    rx: 4.76,
    ry: 6.24,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 92.4,
    cy: 596.12,
    rx: 4.76,
    ry: 6.24,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 92.4,
    cy: 588.5,
    rx: 4.76,
    ry: 6.24,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M110.23 536.34a23.52 23.52 0 0 0 1.78-2.61l-12.52-2 13.54.1a22.81 22.81 0 0 0 .43-18.08l-18.16 9.42 16.75-12.31a22.82 22.82 0 1 0-37.69 25.53 23.21 23.21 0 0 0-2.6 4.16L88.01 549l-17.33-5.82a23 23 0 0 0-1.2 7.32 22.7 22.7 0 0 0 4.88 14.11 22.83 22.83 0 1 0 35.87 0 22.8 22.8 0 0 0 0-28.22z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M69.5 550.45a22.7 22.7 0 0 0 4.88 14.11 22.83 22.83 0 1 0 35.87 0c3.04-3.88-40.75-16.67-40.75-14.11z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 608.08,
    cy: 613.06,
    rx: 29.92,
    ry: 5.75,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 607.58,
    cy: 610.61,
    rx: 3.48,
    ry: 4.56,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 607.58,
    cy: 605.04,
    rx: 3.48,
    ry: 4.56,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 607.58,
    cy: 599.47,
    rx: 3.48,
    ry: 4.56,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 607.58,
    cy: 593.9,
    rx: 3.48,
    ry: 4.56,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 607.58,
    cy: 588.32,
    rx: 3.48,
    ry: 4.56,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 607.58,
    cy: 582.75,
    rx: 3.48,
    ry: 4.56,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 607.58,
    cy: 577.18,
    rx: 3.48,
    ry: 4.56,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M620.62 539.07a16.35 16.35 0 0 0 1.3-1.9l-9.15-1.51 9.9.08a16.79 16.79 0 0 0 1.52-7 16.59 16.59 0 0 0-1.21-6.24l-13.28 6.89 12.25-9a16.68 16.68 0 1 0-27.55 18.68 16.81 16.81 0 0 0-1.91 3l11.88 6.17-12.66-4.25a16.7 16.7 0 0 0 2.69 15.67 16.68 16.68 0 1 0 26.22 0 16.7 16.7 0 0 0 0-20.64z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M590.83 549.36a16.61 16.61 0 0 0 3.57 10.32 16.68 16.68 0 1 0 26.22 0c2.24-2.84-29.79-12.19-29.79-10.32z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 467.93,
    cy: 93.69,
    r: 15.27,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 522.56,
    cy: 25.6,
    r: 25.6,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 488.68,
    cy: 149.82,
    r: 25.6,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 963.43,
    cy: 254.69,
    r: 15.27,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 908.79,
    cy: 186.6,
    r: 25.6,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 942.68,
    cy: 310.82,
    r: 25.6,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 100.27,
    cy: 282.35,
    r: 8.65,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 137.35,
    cy: 249.61,
    r: 14.5,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 67.95,
    cy: 272.1,
    r: 14.5,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 216.08,
    cy: 119.32,
    r: 36.25,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 425.08,
    cy: 303.32,
    r: 20.92,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 579.08,
    cy: 403.32,
    r: 20.92,
    fill: primaryColor,
    opacity: 0.1
  }));
};

UndrawGifts.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawGifts;